export default {
  title: 'Rapports de revenus',
  sections: {
    new_report: 'Nouveau rapport',
  },
  form: {
    period: {
      label: 'Période',
    },
  },
  buttons: {
    export: 'Exporter',
  },
  toasts: {
    failed_to_create_report: 'Échec de la création du rapport',
  },
};
